import classNames from 'classnames';
import { autobind } from 'core-decorators';
import { Component } from 'react';
import settings from '/@/core/settings';
import { _ } from '/@/locale';

import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const delay = 3000;

@autobind
export default class RotateItems extends Component {
    constructor(props) {
        super(props);
        this.state = { index: 0, interval: null };
    }

    componentDidMount() {
        this.setState({
            interval: setInterval(() => {
                this.setState((prevState) => this.setIndex(prevState.index));
            }, delay),
        });
    }

    componentWillUnmount() {
        this.reset();
    }

    reset() {
        clearInterval(this.state.interval);
        this.setState({ index: 0, interval: null });
    }

    setIndex(count) {
        return { index: count >= this.props.items.length - 1 ? 0 : ++count };
    }

    render() {
        return (
            <div className={styles.slideshow}>
                <div
                    className={styles.slideshowSlider}
                    style={{ transform: `translate3d(${-this.state.index * 100}%, 0, 0)` }}
                >
                    {this.props.items.map((item, index) => (
                        <div className={styles.slide} key={index}>
                            <Title className={classNames(styles.itemText, styles[`theme-${settings.app.theme}`])}>
                                {_(item.text)}...
                            </Title>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
